// REACT
import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";

//CSS
import './Header.css';

import Bell from "../../images/Notification/Bell_mobile.svg";
import BellToRead from "../../images/Notification/Bell-to-Read_mobile.svg";
import { Mail } from 'lucide-react';
import user from "../../images/user.svg"
import getAvatar from "../../utils/avatarFormat"

const MobileHeader = ({ userName, openProfile, context, pathname }) => {
    const [lastScrollY, setLastScrollY] = useState(0);
    const [show, setShow] = useState(true);
    const [hasNotification, setHasNotification] = useState(false);
    const [isChatOpen, setIsChatOpen] = useState(false);

    const controlHeader = () => {
        if (typeof window !== 'undefined') {
            if (window.scrollY !== 0) {
                setShow(false);
            } else if (window.scrollY === 0) {
                setShow(true);
            }
            setLastScrollY(window.scrollY);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', controlHeader);
        return () => {
            window.removeEventListener('scroll', controlHeader);
        };
    }, [lastScrollY]);

    useEffect(() => {
        getNotificationStatus();
        async function getNotificationStatus() {
            try {
                const { selectedUserID, idToken } = context;

                const headers = {
                    Authorization: `Bearer ${idToken}`,
                    clientId: selectedUserID,
                };

                const response = await fetch(
                    `/Notifications/GetNotifications?ClientId=${selectedUserID}`,
                    { headers }
                );

                if (!response.ok) {
                    setHasNotification(false);
                    return;
                }

                const data = await response.json();

                // verifica se existe alguma não lida
                const hasUnread = Array.isArray(data)
                    ? data.some((item) => !item.isRead)
                    : false;

                setHasNotification(hasUnread);

            } catch (error) {
                console.error("Error fetching notifications:", error);

                setHasNotification(false);
            }
        }

    }, []);

    return (
        <header className={`header-mobile ${show ? 'visible' : 'hidden'}`}>
            <div className="header-left" onClick={openProfile}>
                <span className="header-mobile__avatar">{getAvatar(userName)}</span>
            </div>
            <div className="header-right">
                <button className="icon-button">
                    {pathname === "/correio" ? (
                        <NavLink
                            to="/">
                            <Mail color="#fff" size={24} />
                        </NavLink>
                    ) : (
                        <NavLink to="/correio">
                            <Mail color="#fff" size={24} />
                        </NavLink>
                    )}
                </button>
                <button className="icon-button">
                    {pathname === "/notificacoes" ?
                        (<NavLink
                            to="/">
                            {hasNotification ? (<img src={BellToRead} />) : (<img src={Bell} />)}

                        </NavLink>) :
                        (<NavLink
                            to="/notificacoes">
                            {hasNotification ? (<img src={BellToRead} />) : (<img src={Bell} />)}
                        </NavLink>)}
                </button>

            </div>
        </header >
    );
}

export default MobileHeader;